export default __webpack_public_path__ + "static/media/close.eb317d3c.svg";